import { User } from "../User/User";

export enum AccountType {
  TraditionalSideDoor = "TraditionalSideDoor",
  FirmsPlus = "FirmsPlus",
  Market = "Market",
}

// TODO: Fix this, it's no longer accurate.
export interface Account {
  id: number;
  name: string;
  created_at: string;
  type: AccountType;
  city?: string;
  region?: string;
  postal_code?: string;
  users?: User[];
  interactions_count?: number;
}

export function formatAccountLocation(
  account: Pick<Account, "city" | "region" | "postal_code">,
): string | null {
  const parts = [account.city, account.region, account.postal_code].filter(
    (value) => value && value.trim(),
  );

  return parts.length > 0 ? parts.join(", ") : null;
}
